import NosOutils from './Outils-formation.js'

export default function content_formation() {
    const ContentFormation =
        <>
            <div className='contentContainer contentFormation'>
                <div className='titreProjet'>
                    <h5 style={{ fontWeight: 'bold', marginBottom: '20px' }}>Aiguisez les compétences de vos apprenants</h5>
                </div>
                <div>
                    <div className='mandat'>
                        <p className="vertical-timeline-element-subtitle">Nous créons des expériences d’apprentissage en ligne dynamiques et stimulantes qui favorisent l’immersion et l’engagement de vos équipes.</p>
                    </div>
                </div>
                <div>
                    <div className='imageOfproject'>
                        <div className='iframeWrapper'>
                            <div style={{ padding: "56.25% 0 0 0", position: "relative" }}><iframe src="https://player.vimeo.com/video/843255858?h=5d1fb517ca&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }} title="BIXI_INTRO_v2_1920x1080_20mbps"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
                        </div>
                    </div>
                    <div className='outil-2'>
                        <div className='solution-body-formation'>
                            <NosOutils />
                        </div>
                    </div>
                </div>
            </div>
        </>

    return ContentFormation;
}
